"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("relements/build/esm/input/text"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
var phrases_1 = __importDefault(require("@src/phrases"));
require("./TaskBody.scss");
var BotActions_1 = require("@src/actions/BotActions");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var utils_1 = require("@src/utils");
// eslint-disable-next-line max-len
var PromptRuleTypes_1 = __importDefault(require("@src/containers/BusinessManager/components/BotPromptTriggerSettings/PromptTriggerEditView/PromptRuleTypes"));
// eslint-disable-next-line max-len
var AddPromptRule_1 = __importDefault(require("@src/containers/BusinessManager/components/BotPromptTriggerSettings/PromptTriggerEditView/AddPromptRule"));
// eslint-disable-next-line max-len
var PromptTriggerRule_1 = __importDefault(require("@src/containers/BusinessManager/components/BotPromptTriggerSettings/PromptTriggerEditView/PromptTriggerRule"));
var constants_1 = require("../../constants");
var const_1 = require("./const");
var KEYWORDS = phrases_1["default"].getPhrase;
var INPUTS = [
    {
        className: 'text',
        component: text_1["default"],
        props: function (data, onChange, taskIndex, isATask) {
            return {
                label: 'Menu Option Title*',
                value: data[constants_1.TASKBOX_KEYS.TASK_NAME],
                onChange: function (value) {
                    onChange(constants_1.TASKBOX_KEYS.TASK_NAME, value.trim(), taskIndex, isATask);
                },
                error: !data[constants_1.TASKBOX_KEYS.TASK_NAME] && 'Title cannot be empty',
            };
        },
    },
    {
        component: text_1["default"],
        props: function (data, onChange, taskIndex, isATask) {
            return {
                label: KEYWORDS('USER_MESSAGE.PLURAL.CAPITALIZE') + "*",
                value: data[constants_1.TASKBOX_KEYS.USER_SAYS],
                onChange: function (value) {
                    onChange(constants_1.TASKBOX_KEYS.USER_SAYS, value.trim(), taskIndex, isATask);
                },
                error: !data[constants_1.TASKBOX_KEYS.USER_SAYS] &&
                    KEYWORDS('USER_MESSAGE.PLURAL.CAPITALIZE') + " cannot be empty",
            };
        },
    },
    {
        label: 'FORCE_BREAK',
        key: 'forceBreak1',
        component: function () { return react_1["default"].createElement("div", { style: { minWidth: '100%' } }); },
        props: function () {
            return null;
        },
    },
    {
        className: 'checkbox',
        component: checkbox_1["default"].Item,
        props: function (data, onChange, taskIndex, isATask) {
            return {
                label: 'Location Required',
                value: data[constants_1.TASKBOX_KEYS.LOCATION_REQUIRED],
                onChange: function (checked) {
                    return onChange(constants_1.TASKBOX_KEYS.LOCATION_REQUIRED, checked, taskIndex, isATask);
                },
            };
        },
    },
    {
        className: 'checkbox',
        component: checkbox_1["default"].Item,
        props: function (data, onChange, taskIndex, isATask) {
            return {
                label: 'Visible on Menu',
                value: data[constants_1.TASKBOX_KEYS.TASKBOX_SUPPORT],
                onChange: function (checked) {
                    return onChange(constants_1.TASKBOX_KEYS.TASKBOX_SUPPORT, checked, taskIndex, isATask);
                },
            };
        },
    },
];
var handleRemoveRules = function (index, copyRules, ruleList, onChange, taskIndex) {
    if (ruleList.length > 1) {
        var filterRules = ruleList.filter(function (data, i) {
            return i !== index;
        });
        copyRules.rule_list = filterRules;
        onChange(constants_1.TASKBOX_KEYS.TASK_RULES, copyRules, taskIndex, true);
    }
    else {
        BotActions_1.createAlert('There should be atleast 1 rule', null, MogamboConstants_1.AlertTypes.NEGATIVE);
    }
};
var TaskBody = function (_a) {
    var _b, _c, _d, _e;
    var taskBodyData = _a.taskBodyData, onChange = _a.onChange, taskIndex = _a.taskIndex, _f = _a.disabled, disabled = _f === void 0 ? true : _f;
    var ruleList = ((_b = taskBodyData === null || taskBodyData === void 0 ? void 0 : taskBodyData.rules) === null || _b === void 0 ? void 0 : _b.rule_list) || [];
    var copyRules = JSON.parse(JSON.stringify(taskBodyData.rules || {}));
    return (react_1["default"].createElement("div", { className: "taskBody" },
        react_1["default"].createElement("div", { className: "taskBodyTitle" }, "Configure Menu"),
        react_1["default"].createElement("div", { className: "taskBodyRow" }, INPUTS.map(function (input) {
            var Input = input.component;
            var inputProps = input.props(taskBodyData, onChange, taskIndex, true);
            return (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(Input, __assign({}, inputProps, { disabled: disabled, className: input.className + " taskBodyInput" }))));
        })),
        react_1["default"].createElement("div", null,
            react_1["default"].createElement(box_1["default"], { padding: "0", marginTop: "16px", marginBottom: "16px", alignItems: "center" },
                react_1["default"].createElement(box_1["default"], { padding: "0", marginRight: "16px" },
                    react_1["default"].createElement("div", { className: "taskBodyToggle" }, "Rule-based Visibility")),
                react_1["default"].createElement(toggle_1["default"], { disabled: utils_1.isProduction(), value: (_c = taskBodyData === null || taskBodyData === void 0 ? void 0 : taskBodyData.rules) === null || _c === void 0 ? void 0 : _c.enabled, onChange: function (value) {
                        copyRules.enabled = value;
                        onChange(constants_1.TASKBOX_KEYS.TASK_RULES, copyRules, taskIndex, true);
                    } })),
            ((_d = taskBodyData === null || taskBodyData === void 0 ? void 0 : taskBodyData.rules) === null || _d === void 0 ? void 0 : _d.enabled) && (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(box_1["default"], { padding: "0", marginBottom: "16px" },
                    react_1["default"].createElement(checkbox_1["default"].Item, { disabled: utils_1.isProduction(), label: "Always Show on Mobile", value: (_e = taskBodyData === null || taskBodyData === void 0 ? void 0 : taskBodyData.rules) === null || _e === void 0 ? void 0 : _e.show_on_mobile, onChange: function (checked) {
                            copyRules.show_on_mobile = checked;
                            onChange(constants_1.TASKBOX_KEYS.TASK_RULES, copyRules, taskIndex, true);
                        } }),
                    react_1["default"].createElement(tooltip_1["default"], { themed: true, tooltip: "On mobile SDKs, menu options with rule-based visibility are automatically hidden. However, if you want this specific menu option to always show on mobile, please enable this setting.", position: "TOP" },
                        react_1["default"].createElement(InfoIconV4_1["default"], { size: "small", iconColor: "grey.dark", marginLeft: "-20px" }))),
                react_1["default"].createElement(PromptRuleTypes_1["default"], { options: const_1.RULES_TYPE, value: {
                        title: taskBodyData.rules.clause === 'AND' ? 'And' : 'Or',
                        value: taskBodyData.rules.clause,
                    }, onChange: function (val) {
                        copyRules.clause = val.value;
                        onChange(constants_1.TASKBOX_KEYS.TASK_RULES, copyRules, taskIndex, true);
                    }, text: "Rule Type", isTask: true }),
                react_1["default"].createElement("div", null,
                    react_1["default"].createElement(AddPromptRule_1["default"], { onClick: function () {
                            copyRules.rule_list.push({
                                variable: 'page_url',
                                operator: 'eq',
                                value: '',
                                meta: {},
                            });
                            onChange(constants_1.TASKBOX_KEYS.TASK_RULES, copyRules, taskIndex, true);
                        }, text: "Rules", isTask: true }),
                    react_1["default"].createElement("div", null, ruleList.map(function (rule, index) {
                        var error = {};
                        if (!rule.value || rule.value.trim() === '') {
                            error = {
                                value: 'Please select an appropriate Value',
                            };
                        }
                        if (!rule.meta.key || rule.meta.key.trim() === '') {
                            error = __assign(__assign({}, error), { meta: {
                                    key: 'Please fill appropriate value for the meta field',
                                } });
                        }
                        return (react_1["default"].createElement(PromptTriggerRule_1["default"], __assign({ supportedTypes: const_1.SUPPORTED_TYPES, supportedVariables: const_1.SUPPORTED_VARIABLES, supportedOperatorsByType: const_1.SUPPORTED_OPERATORS_BY_TYPE, supportedOperators: const_1.SUPPORTED_OPERATORS, fixedValueOperators: const_1.FIXED_VALUE_OPERATORS, error: error, key: index }, rule, { onChange: function (key, value) {
                                copyRules.rule_list[index][key] = value;
                                onChange(constants_1.TASKBOX_KEYS.TASK_RULES, copyRules, taskIndex, true);
                            }, onRemove: function () {
                                handleRemoveRules(index, copyRules, ruleList, onChange, taskIndex);
                            } })));
                    }))))))));
};
exports["default"] = TaskBody;
